module.exports = __webpack_public_path__ + "static/media/LogoDE.3f7f8bd4.svg";